import {
  UPDATE_DATA_RETENTION_POLICY,
  UPDATE_DATA_RETENTION_POLICY_SUCCESS,
  UPDATE_DATA_RETENTION_POLICY_ERROR,
} from './actionTypes';

const initialState = {
  errorUpdateDataRetentionPolicy: '',
  loadingUpdateDataRetentionPolicy: false,
  successUpdateDataRetentionPolicy: '',
};

const updateDataRetentionPolicy = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DATA_RETENTION_POLICY:
      state = { ...state, loadingUpdateDataRetentionPolicy: true };
      break;
    case UPDATE_DATA_RETENTION_POLICY_SUCCESS:
      state = {
        ...state,
        loadingUpdateDataRetentionPolicy: false,
        successUpdateDataRetentionPolicy: action.payload.message,
      };
      break;
    case UPDATE_DATA_RETENTION_POLICY_ERROR:
      state = { ...state, errorUpdateDataRetentionPolicy: action.payload, loadingUpdateDataRetentionPolicy: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updateDataRetentionPolicy;
